import { useTranslation } from 'react-i18next';
import PlanOption from '~/pages/Subscription/Checkout/PlanOption';
import { PlanType } from '~/types/subscriptionTypes';

const PLAN_IDS = {
  MONTHLY: 3,
  YEARLY: 4,
} as const;

export default function PlanToggle({
  selectedPlanId,
  monthlyPlan,
  yearlyPlan,
  onPlanChange,
}: {
  selectedPlanId: number;
  monthlyPlan: PlanType;
  yearlyPlan: PlanType;
  onPlanChange: (planId: number) => void;
}) {
  const { t } = useTranslation('app');

  return (
    <div className="flex w-full rounded-[16px] border border-gray bg-white p-0 mb-3x">
      <PlanOption
        id={PLAN_IDS.MONTHLY}
        title={t('subscriptionQuarterly')}
        price={monthlyPlan.price}
        oldPrice={monthlyPlan.price_before_discount}
        period={`/3 ${t('months')}`}
        isSelected={selectedPlanId === PLAN_IDS.MONTHLY}
        onPlanChange={onPlanChange}
      />
      <PlanOption
        id={PLAN_IDS.YEARLY}
        title={t('subscriptionYearly')}
        price={yearlyPlan.price}
        oldPrice={yearlyPlan.price_before_discount}
        period={`/${t('year')}`}
        isSelected={selectedPlanId === PLAN_IDS.YEARLY}
        showBadge={true}
        onPlanChange={onPlanChange}
      />
    </div>
  );
}
